import { dropBoolean } from 'utils/drops';

const getAnpFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'codigo',
    label: 'Código',
  },
  {
    name: 'descricao',
    label: 'Descrição',
    initial: true,
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropBoolean,
  },
];

export default getAnpFilterFields;
